import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "testimonials__card" }
const _hoisted_2 = { class: "testimonials__content" }
const _hoisted_3 = { class: "testimonials__user" }
const _hoisted_4 = { class: "testimonials__user--pic" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "testimonials__user--info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString($props.content), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("figure", _hoisted_4, [
        _createElementVNode("img", {
          src: $props.userPic,
          alt: ""
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", null, _toDisplayString($props.userName), 1),
        _createElementVNode("p", null, _toDisplayString($props.userPosition), 1)
      ])
    ])
  ]))
}